<template>
  <modal
    name="previewAudioModal"
    :click-to-close="true"
    :styles="styles"
    :width="'100%'"
    :height="'100%'"
    @closed="onClose"
    @before-open="beforeOpen"
    @opened="opened"
  >
    <div class="preview-audio-modal">
      <div class="audio-box">
        <audio
          ref="audioDom"
          autoplay
          :src="srcUrl"
          volume="1"
        ></audio>
        <div class="top">
          试听音频
        </div>
        <div class="mid">
          <div style="width:16px;height:16px;margin:0 8px 0 0;">
            <iconfont
              style="font-size:14px;"
              name="#icon16-31yinpinpianduan"
            ></iconfont>
          </div>

          <div>{{ params.name }}</div>
        </div>
        <div class="bottom">
          <el-slider
            ref="myelslider"
            v-model="current"
            style="width:400px;"
            :max="duration"
            :show-tooltip="false"
            @change="sliderInput"
          ></el-slider>
          <div class="time">
            {{ timeStr }}
          </div>
        </div>
        <div
          class="del-btn"
          :style="closeBtnStyle"
          @click="close"
        >
          <iconfont
            class="icon-hover"
            style="font-size:12px;"
            name="#icon20-12guanbianniujiaohu"
          ></iconfont>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      srcUrl: '',
      styles: {
        width: '100%',
        height: '100%',
        borderRadius: 0,
        overflow: 'visible',
        backgroundColor: '#00000011',
        boxShadow: 'none'
      },
      imgStyle: 'height:100%',
      imgEle: null,
      closeBtnStyle: {},
      duration: 0,
      current: 0,
      params: {}
    };
  },
  computed: {
    timeStr() {
      let f = (t) => {
        return (
          parseInt(t / 60)
            .toString()
            .padStart(2, 0) +
          ':' +
          parseInt(t % 60)
            .toString()
            .padStart(2, 0)
        );
      };
      return `${f(this.current)}/${f(this.duration)}`;
    }
  },
  mounted() {
    //console.log('mounted mounted');
    window.addEventListener('resize', this.changSize);
    this.changSize();
  },
  methods: {
    beforeOpen({ params }) {
      this.params = params;
    },
    onClose() {
      //window.removeEventListener('resize', this.changSize);
    },
    close() {
      //console.log(this.$refs.audioDom);
      this.$refs.audioDom.pause();
      this.params = {};
      this.srcUrl = '';
      this.current = 0;
      this.duration = 0;
      this.$modal.hide('previewAudioModal');
    },
    changSize() {
      // if (e && e.target && e.target.offsetHeight) {
      //   this.imgEle = e.target;
      // }
      // //console.log('window', window.innerWidth);
      // if (this.imgEle && this.imgEle.offsetHeight) {
      //   this.imgBoxStyle = {
      //     width: this.imgEle.offsetWidth - 1 + 'px',
      //     height: this.imgEle.offsetHeight - 1 + 'px'
      //   };
      // } else {
      //   let w = 0.644 * window.innerWidth;
      //   this.imgBoxStyle = {
      //     width: w + 'px',
      //     height: (w * 9) / 16 + 'px'
      //   };
      // }
      // let bw = 0.03125 * window.innerWidth;
      // this.closeBtnStyle = {
      //   width: bw + 'px',
      //   height: bw + 'px',
      //   right: -bw - 30 * (window.innerWidth / 1920) + 'px'
      // };
    },
    opened() {
      this.$nextTick(() => {
        this.$refs.audioDom.addEventListener('loadedmetadata', (e) => {
          this.duration = e.target.duration;
          this.current = 0;
        });
        this.$refs.audioDom.addEventListener('timeupdate', (e) => {
          this.current = e.target.currentTime;
        });
        this.srcUrl = this.params.url;
      });
      //this.changSize();
      //console.log('opened opened opened');
    },
    sliderInput(e) {
      this.$refs.audioDom.pause();
      // if(e < this.current)
      //   console.log('sliderInput sliderInput sliderInput', e);
      this.current = e;
      this.$refs.audioDom.currentTime = this.current;
      this.$refs.audioDom.play();
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-audio-modal {
  position: relative;
  width: 100%;
  height: 100%;
  // background: #00000099;
  display: flex;
  justify-content: center;
  align-items: center;
  .audio-box {
    background: white;
    position: relative;
    width: 567px;
    height: 174px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    .top {
      margin: 29px 0 29px 0;
      height: 14px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #343434;
      line-height: 14px;
    }
    .mid {
      height: 20px;
      display: flex;
      padding: 0 0 0 40px;
    }
    .bottom {
      display: flex;
      height: 20px;
      line-height: 20px;
      margin: 10px 0 0 0;
      padding: 0 0 0 45px;
      /deep/ .el-slider__button {
        border: 0px !important;
        background: #2f58fe;
        box-shadow: 0px 5px 30px 0px rgba(22, 64, 234, 0.16);
      }
      /deep/ .el-slider__runway {
        .el-slider__bar {
          background: #2f58fe;
        }
      }
      .time {
        margin: 9px 0 0 12px;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .del-btn {
      position: absolute;
      top: 16px;
      right: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 14px;
      height: 14px;
      background: #f9f9fb44;
      border-radius: 50%;
      color: #666;
      &:hover {
        color: #9e9e9e;
      }
    }
  }
}
</style>
